import EntryDetailContainer from 'components/EntryDetail/EntryDetailContainer'

export default {
  Container: EntryDetailContainer,
}
